import { useAuth } from 'hooks';
import { RecurringSeriesWebSocketMessage } from 'model/WebSockets';
import { useCallback } from 'react';
import { useActionCableChannel } from './useActionCableChannel';

const isProcessingFinished = (message: RecurringSeriesWebSocketMessage): boolean =>
    message.progress === undefined || message.progress.processed >= message.progress.total;

export const useRecurringSeriesChannel = (
    recurringUuid: string | undefined,
    onFinished: () => void,
    onProgress?: () => void
): void => {
    const auth = useAuth();

    const onReceived = useCallback(
        (message: RecurringSeriesWebSocketMessage) => {
            if (isProcessingFinished(message)) {
                onFinished();
            } else {
                onProgress?.();
            }
        },
        [onFinished, onProgress]
    );

    useActionCableChannel<RecurringSeriesWebSocketMessage>({
        channel: 'RecurringSeriesChannel',
        params: {
            marketplace_id: auth.marketplaceId,
            uuid: recurringUuid
        },
        enabled: Boolean(auth.signedIn && auth.marketplaceId && recurringUuid),
        onReceived,
        subscriptionDeps: [auth.marketplaceId, recurringUuid],
        logLabel: 'RecurringSeriesChannel'
    });
};

export default useRecurringSeriesChannel;
